import BaseApiAction from '@Actions/base-api-action';
import { Actions } from '@Context/common/general/context';

export default class GetAssignableTeams extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-getAssignableTeams',
      payload: {
        user_id: this._payload.user_id || null,
        club_id: this._payload.club_id || null,
      },
    });
  }

  onSuccess(data) {

    for(let i = 0; i < data.length; i++) {
      data[i].filterString = `${data[i].name} ${data[i].group}`.toLowerCase();
    }

    this._dispatch({
      type: Actions.CoreActions.UpdateState,
      payload: {
        admin: {
          teams: {
            unassignedTeams: data,
          },
        },
      },
    });
    super.onSuccess(data);
  }
}
